module.exports = __webpack_public_path__ + "img/Komisaris-Independent-Ahmad-Subagyo.618a8108.jpg";